import React from "react";

const NAV_OPTIONS = [
    { value: "sidebar", label: "Sidebar", desc: "Vertical navigation on the left" },
    { value: "top-nav", label: "Top Navigation", desc: "Horizontal navigation bar at the top" },
    { value: "none", label: "None", desc: "No default navigation layout" },
];

const WIDTH_OPTIONS = [
    { value: "1200px", label: "Compact (1200px)" },
    { value: "1400px", label: "Default (1400px)" },
    { value: "1600px", label: "Wide (1600px)" },
    { value: "100%", label: "Full Width" },
];

const SPACING_OPTIONS = [
    { value: "compact", label: "Compact", desc: "Tighter spacing between elements" },
    { value: "default", label: "Default", desc: "Standard spacing" },
    { value: "spacious", label: "Spacious", desc: "More breathing room" },
];

export default function DesignSystemLayout({ layout, onChange }) {
    const handleChange = (key, value) => {
        onChange({ ...layout, [key]: value });
    };

    return (
        <div className="space-y-5">
            <h3 className="text-sm font-semibold">Layout Conventions</h3>
            <div className="space-y-4">
                <div>
                    <label className="text-sm font-medium">Navigation Style</label>
                    <div className="grid grid-cols-3 gap-3 mt-2">
                        {NAV_OPTIONS.map((opt) => (
                            <button
                                key={opt.value}
                                type="button"
                                onClick={() => handleChange("navStyle", opt.value)}
                                className={`p-3 text-left border rounded-md transition-colors ${
                                    (layout?.navStyle || "sidebar") === opt.value
                                        ? "border-primary bg-primary/5"
                                        : "border-input hover:bg-accent"
                                }`}
                            >
                                <div className="text-sm font-medium">{opt.label}</div>
                                <div className="text-xs text-muted-foreground mt-0.5">{opt.desc}</div>
                            </button>
                        ))}
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="text-sm font-medium">Max Page Width</label>
                        <select
                            value={layout?.maxWidth || "1400px"}
                            onChange={(e) => handleChange("maxWidth", e.target.value)}
                            className="block w-full mt-1 px-3 py-2 border border-input rounded-md bg-background text-sm"
                        >
                            {WIDTH_OPTIONS.map((w) => (
                                <option key={w.value} value={w.value}>{w.label}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className="text-sm font-medium">Spacing Scale</label>
                        <select
                            value={layout?.spacingScale || "default"}
                            onChange={(e) => handleChange("spacingScale", e.target.value)}
                            className="block w-full mt-1 px-3 py-2 border border-input rounded-md bg-background text-sm"
                        >
                            {SPACING_OPTIONS.map((s) => (
                                <option key={s.value} value={s.value}>{s.label}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    );
}
